<template>
  <div class="enterprise">
    <div class="opreationBox clearfix">
      <div class="fl">
        <el-form
          :inline="true"
          :model="params"
          class="demo-form-inline"
          label-width="120px"
          @submit.native.prevent
        >
          <el-form-item label="战略合伙人名称">
            <el-input
              placeholder="请输入战略合伙人名称"
              clearable
              v-model="params.Name"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button
              style="width:98px"
              type="primary"
              @click="handleCurrentChange(1)"
            >查询</el-button>
            <el-button
              style="width:98px"
              type="danger"
              plain
              @click="reset"
            >重置</el-button>
          </el-form-item>
          <el-form-item
            label=""
            style="float:right"
          >
            <el-button
              style="width:128px"
              type="primary"
              @click="addEnterprise"
            >
              新增战略合伙人
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="fr">
        <el-button type="primary" @click="download('战略合伙人月度综合业绩表')">战略合伙人月度综合业绩表</el-button>
      </div>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column
          header-align="center"
          prop="name"
          label="战略合伙人名称"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column header-align="center" prop="partnerCount" label="战略合伙人成员"/>
        <el-table-column label="战略合伙人生效状态" align="center" prop="state">
          <template slot-scope="{row, $index}">
            <el-switch
              v-model="row.state"
              :active-value="0"
              :inactive-value="1"
              active-color="#049EA3"
              inactive-color="#909399"
              @change="changeState(row, $index)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="会员数量" align="center" prop="panelCount" />
        <el-table-column label="关注会员数量" align="center" prop="panelFocusCount" />
        <el-table-column label="战略合伙人二维码" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="lookCode(row)">点击查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="所属发展专员" align="center" prop="developerName" />
        <el-table-column label="发展专员电话" align="center" prop="developerPhone" />
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="250"
        >
          <template slot-scope="scope">
            <el-button
              plain
              size="mini"
              @click="look(scope.row)"
              style="margin-bottom: 10px;"
            >
              详情
            </el-button>
            <el-button
              @click="edit(scope.row)"
              size="mini"
              plain
              style="margin-bottom: 10px;"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              @click="del(scope.row)"
              size="mini"
              plain
              style="margin-bottom: 10px;"
            >
              删除
            </el-button>
            <el-button
              @click="editStaff(scope.row)"
              size="mini"
              plain
            >
              编辑战略合伙人成员
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="params.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <enterprise-dialog ref="enterpriseDialog" @done="editEnterpriseDone" />
    <enterprise-staff-dialog ref="enterpriseStaffDialog" @done="editEnterpriseStaffDone" />
    <enterprise-qrcode-dialog ref="enterpriseQrcodeDialog" />
    <downloadDialog ref="downloadDialog" />
    <enterpriseStaff ref="enterpriseStaff" @done="getList" />
  </div>
</template>

<script>
  import { getEnterprise as getList, delEnterprise as del, enterpriseDownloadPerformances, updateEnterprise } from 'api/request'
  import { SetTableH } from '../../utils/utils'
  import enterpriseDialog from './components/enterpriseDialog'
  import enterpriseStaffDialog from "./components/enterpriseStaffDialog"
  import enterpriseQrcodeDialog from "./components/enterpriseQrcodeDialog"
  import downloadDialog from "@/components/downloadDialog"
  import enterpriseStaff from "./components/enterpriseStaff";
  export default {
    components: {
      enterpriseDialog,
      enterpriseStaffDialog,
      enterpriseQrcodeDialog,
      downloadDialog,
      enterpriseStaff
    },
    data() {
      return {
        params: {
          PageIndex: 1,
          PageSize: 10,
          Name: undefined
        },
        total: 0,
        dataList: [],
        loading: true,
        tableH: '250'
      }
    },
    created() {
      this.getList()
    },
    mounted() {
      SetTableH(this)
    },
    methods: {
      async getList() {
        let data = await getList(this.params)
        if (data) {
          this.dataList = data.rows
          this.total = data.total
          this.loading = false
        }
      },
      reset() {
        for (let key in this.params) {
          this.params[key] = ''
        }
        this.params.PageIndex = 1
        this.params.PageSize = 10
        this.handleCurrentChange(1)
      },
      handleSizeChange(val) {
        this.params.PageSize = val
        this.getUserList()
      },
      handleCurrentChange(val) {
        this.params.PageIndex = val
        this.getList()
      },
      addEnterprise() {
        this.$refs.enterpriseDialog.show({})
      },
      edit(data) {
        const { id, name } = data
        this.$refs.enterpriseDialog.show({ id, name})
      },
      editEnterpriseDone(id) {
        id ? this.getList() : this.handleCurrentChange(1)
      },
      editStaff(data) {
        const params = {
          enterpriseId: data.id,
          panels: JSON.parse(JSON.stringify(data.partners))
        }
        this.$refs.enterpriseStaff.show(params)
      },
      editEnterpriseStaffDone() {
        this.getList()
      },
      del(data) {
        const { id } = data
        this.$confirm('是否删除','是否删除该战略合伙人?',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          del(id).then(res => {
            if (res) {
              this.$message.success('删除成功')
              this.handleCurrentChange(1)
            } else {
              that.$message.error('删除失败')
            }
          })
        }).catch(() => {})
      },
      changeState(row, index) {
        updateEnterprise({ id: row.id, name: row.name, state: row.state  }).then(data => {
          if (data) {
            this.$message.success('设置成功')
            this.$set(row, 'state', row.state)
            this.$set(this.dataList, index, row)
          } else {
            this.$message.error('设置失败')
            this.$set(row, 'state', !row.state)
            this.$set(this.dataList, index, row)
          }
        })
      },
      lookCode(row) {
        const { name, id } = row
        this.$refs.enterpriseQrcodeDialog.show({ id, name })
      },
      look(row) {
        const { id } = row
        this.$router.push({ path: '/enterpriseDetail', query: { id }})
      },
      download(title) {
        this.$refs.downloadDialog.show({ api: enterpriseDownloadPerformances, title })
      }
    }
  }
</script>

<style lang="scss">
  .enterprise{
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
  }
</style>
